// extracted by mini-css-extract-plugin
export var container = "_fb-0";
export var content = "_fb-3";
export var customerTitle = "_fb-4";
export var empty = "_fb-5";
export var gray = "_fb-6";
export var header = "_fb-7";
export var info = "_fb-8";
export var loading = "_fb-2";
export var loadingCard = "_fb-9";
export var oneLine = "_fb-a";
export var personName = "_fb-e";
export var pillContainer = "_fb-b";
export var selected = "_fb-1";
export var text = "_fb-c";
export var twoLines = "_fb-d";
export var unread = "_fb-f";
export var unreadIndicator = "_fb-g";